import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "evrideo-simple-text-input",
  templateUrl: "./simple-text-input.component.html",
  styleUrls: ["./simple-text-input.component.scss"],
})
export class SimpleTextInputComponent implements OnInit, OnChanges {
  @Input()
  overrideStyle = {};

  @Input()
  value: string;

  @Input()
  placeholder = "";

  @Input()
  pattern = "";

  @Output()
  valueChange = new EventEmitter<string>();

  styleObject: any = {
    "line-height": "30px",
    height: "30px",
    "border-radius": "4px",
    transition: "all 0.2s ease",
    "border-style": "solid",
    "border-color": "#e1e6eb",
    "border-width": "1px",
    color: "#232f3a",
    width: "100%",
    padding: "0 15px",
    "font-size": "0.9em",
  };

  @Input()
  disabled = false;

  constructor() {}

  ngOnInit() {
    this.initStylesObject();
  }

  initStylesObject() {
    this.styleObject = { ...this.styleObject, ...this.overrideStyle };
    console.log("initStylesObject", this.value, this.styleObject);
  }

  ngOnChanges(changes) {
    console.log("text-editor-> on changes ", changes);
    this.initStylesObject();
  }

  onChange($event: Event) {
    const target: any = $event.target;
    this.valueChange.emit(target.value);
    console.log(
      "on change text",
      this.value,
      this.value.length,
      this.styleObject,
    );
  }
}
